import React from "react";
import { Box, Container, Typography } from "@mui/material";

import Navbar from "./Navbar";
import Footer from "./HomeFooter";

const clients = [
    {
        id: "mash-matriculation-school",
        name: "Mash Matriculation School",
        logo: "/images/mash.png",
    },
    {
        id: "nannilam-college",
        name: "Government Arts And Science College Nannilam",
        logo: "/images/nannilam.jpg",
    },
    {
        id: "jurong-academy",
        name: "Jurong Academy",
        logo: "/images/jurong.png",
    },
    {
        id: "trent-international-college",
        name: "Trent International College",
        logo: "/images/trend.png",
    },
    {
        id: "newton-international-college",
        name: "Newton International College",
        logo: "/images/newton.png",
    },
    {
        id: "aeg-international-college",
        name: "AEG International College",
        logo: "/images/aeg.png",
    },
    {
        id: "allians-international-college",
        name: "Allians International College",
        logo: "/images/allians.png",
    },
    {
        id: "thangam-matric-school",
        name: "Thangam Matric.HR.Sec. School",
        logo: "/images/thangam.jpeg",
    },
    {
        id: "kumarappa-school",
        name: "Dr. J.C. Kumarappa Centenary Vidya Mandir Matric Higher Secondary School",
        logo: "/images/kumarappa.jpg",
    },
];

/* ================= CLIENT CARD ================= */

const ClientCard = ({ client }) => {
    return (
        <Box
            sx={{
                width: "100%",
                height: {
                    xs: 240,
                    md: 250,
                },

                background: "#fffdfb",
                border: "1px solid #d9e2e8",
                borderRadius: 3,

                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",

                px: 2,
                py: 2,

                boxSizing: "border-box",
            }}
        >
            {/* LOGO */}

            <Box
                sx={{
                    width: {
                        xs: 105,
                        md: 120,
                    },

                    height: {
                        xs: 105,
                        md: 120,
                    },

                    borderRadius: 3,
                    background: "#eef7ff",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    overflow: "hidden",
                    flexShrink: 0,

                    mb: 2.5,
                }}
            >
                <Box
                    component="img"
                    src={client.logo}
                    alt={client.name}
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        p: 1,
                        boxSizing: "border-box",
                    }}
                />
            </Box>

            {/* NAME */}

            <Typography
                sx={{
                    fontFamily: "Georgia, serif",

                    fontSize: {
                        xs: "1.05rem",
                        md: "1.15rem",
                    },

                    fontWeight: 600,

                    color: "#123b68",

                    textAlign: "center",

                    lineHeight: 1.3,

                    maxWidth: 300,
                }}
            >
                {client.name}
            </Typography>
        </Box>
    );
};

/* ================= CLIENTS PAGE ================= */

const Clients = () => {
    return (
        <>
            <Navbar />

            <Box
                sx={{
                    minHeight: "100vh",

                    background: "#f8f3ef",

                    pt: {
                        xs: 11,
                        md: 13,
                    },

                    pb: 8,
                }}
            >
                <Container maxWidth="xl">

                    {/* TITLE */}

                    <Box sx={{ textAlign: "center", mb: { xs: 5, md: 6, }, }} > 
<Typography
    sx={{
        fontFamily: "Georgia, serif",
        fontSize: {
            xs: "2.5rem",
            sm: "3.2rem",
            md: "4rem",
        },
        fontWeight: 700,
        color: "#123b68",
        lineHeight: 1.1,
    }}
>
    Our Valuable Clients
</Typography>

                              </Box>

                    {/* ================= 3 × 4 GRID ================= */}

                    <Box
                        sx={{
                            display: "grid",

                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2, 1fr)",
                                md: "repeat(3, 1fr)",
                            },

                            gap: {
                                xs: 2.5,
                                md: 3,
                            },

                            maxWidth: 1100,

                            mx: "auto",
                        }}
                    >
                        {clients.map((client) => (
                            <ClientCard
                                key={client.id}
                                client={client}
                            />
                        ))}
                    </Box>

                </Container>
            </Box>
                            <Footer />

        </>
    );
};

export default Clients;